module.exports = __webpack_public_path__ + "fonts/iconfont.55aa052d.ttf";